export default __webpack_public_path__ + "static/media/diamond-cut-5@3x.030ab8c2.jpg";